import Vue from 'vue'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'RoutingRulesForm',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    },

    type: String,
    disabled: Boolean
  },

  computed: {
    validation() {
      if (!this.proxy.type) {
        return false
      }

      if (!this.proxy.title) {
        return false
      }

      if (Array.isArray(this.proxy.ProviderGroups)) {
        if (this.proxy.ProviderGroups.length === 0) {
          return false
        } else {
          return !this.proxy.ProviderGroups.some(({ id, percentage }) => {
            return id === undefined || percentage === undefined || percentage < 0 || percentage > 100
          })
        }
      }

      return true
    }
  },

  watch: {
    'proxy.type'() {
      Vue.set(this.proxy, 'ProviderGroups', [])
    },
    validation() {
      this.$emit('validation', this.validation)
    }
  },

  mounted() {
    this.$emit('validation', this.validation)

    if (this.type) {
      this.proxy.type = this.type
    }
  },

  render
}
